import { render, staticRenderFns } from "./aiSummaryInfo.vue?vue&type=template&id=27b28485&scoped=true"
import script from "./aiSummaryInfo.vue?vue&type=script&lang=js"
export * from "./aiSummaryInfo.vue?vue&type=script&lang=js"
import style0 from "./aiSummaryInfo.vue?vue&type=style&index=0&id=27b28485&prod&lang=scss&scoped=true"
import style1 from "./aiSummaryInfo.vue?vue&type=style&index=1&id=27b28485&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b28485",
  null
  
)

export default component.exports